import { checkProductType } from '../utils/checkProductType';
import * as eventActions from '../actions/eventActions';
import { get } from 'lodash-es';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === eventActions.PIGGYBANK_EVENT) {
    const productCode = get(action, 'event.values.product', '');
    if (
      get(action, 'event.type') === 'onNavigate' &&
      get(action, 'event.component') === 'Wizard' &&
      productCode
    ) {
      const {
        productDescription,
        productType,
        productDescriptionForAnalytics,
      } = checkProductType(productCode);

      return {
        productCode: productCode.split('_')[0].concat('_HBSP'),
        productDescription,
        productDescriptionForAnalytics,
        productType,
      };
    }
    return state;
  }
  return state;
};
